import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=3a785566&scoped=true&"
import script from "./AppMenu.ts?vue&type=script&lang=ts&"
export * from "./AppMenu.ts?vue&type=script&lang=ts&"
import style0 from "./AppMenu.scss?vue&type=style&index=0&id=3a785566&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a785566",
  null
  
)

export default component.exports